// React / Gatsby --------------------------------------------------
import React, { useState } from 'react';
import { graphql } from 'gatsby'

// Plugins ---------------------------------------------------------
import { motion } from 'framer-motion'

// Layout ----------------------------------------------------------
import { Layout } from '../components/layout'

// Data Hooks ------------------------------------------------------
import * as Context from '../components/context'
import { useChapterData } from '../hooks/chapter_data'
import Intro from "../audio/yir-demo-04.mp3"

// Components ------------------------------------------------------
import { Banner, BannerContent, ScrollArrow } from '../components/banner'
import { CoverImage } from '../components/images'
import { ChapterNavigation } from '../components/chapter_navigation'
import { AudioPlayer } from '../components/audioPlayer';
import { Paragraph } from '../components/slide';

// Chapter Function ------------------------------------------------
export default function Chapter01({data}) {
	const chapterData = useChapterData()
	const title = chapterData.chapter1.chapter_title
	const number = chapterData.chapter1.chapter_number

	return (
		<Context.Template.Provider
			value={{
				pageTitle: title,
				number: number,
				pageID: `chapter-${number}`,
				footerTheme: "light",
				navTheme: "ghostWhite",
			}}
		>
			<Layout>
				<Banner whisper="null">
					<CoverImage
						imgSrc={data.coverImage.childImageSharp.fluid}
						screen={true}
						imgTag="ages_cover"
						imgFit="cover"
					/>
					<BannerContent arrowTheme="none" arrowPos="left">
						<>
							<div className="chapter-title">
								A Year for the Ages
							</div>
						</>

						<IntroArrow />

						<AudioPlayer audio={Intro} />

						<Paragraph direction="down" id="top">
							Here in the sunset of 2020, listen to the wisdom of
							Howard Thurman: “In the stillness of the quiet,” he
							said, “if we listen, we can hear the whisper of the
							heart giving strength to weakness, courage to fear,
							hope to despair.”
						</Paragraph>
						<Paragraph direction="down">
							Think about some of the words and phrases that have
							come to define this historic year:
						</Paragraph>
						<Paragraph direction="down">
							Pandemic. Coronavirus. Masks. Swab. Zoom. Vaccine.
							George Floyd. Ahmaud Arbery. Breonna Taylor.
							Protests. Racism. Antiracism. Trump. Biden. Kamala
							Harris. Anthony Fauci.
						</Paragraph>
						<Paragraph direction="down">
							Yet amid so much darkness, glimmers of light give us
							hope.
						</Paragraph>
						<Paragraph direction="down">
							Black Americans did not have to protest alone
							against the violence and systemic racism they’ve
							faced. They were joined in marches and rallies by
							people of all colors and backgrounds, who recognized
							this was an issue for all of us to take on together.
						</Paragraph>
						<Paragraph direction="down">
							Scientists seized on the pursuit of a vaccine,
							something that should take years, or even decades,
							to develop, but could be delivered to citizens in
							record time.
						</Paragraph>
						<Paragraph direction="down">
							Amid all the election-year talk about the death of
							democracy, a record 160 million votes were cast in
							2020. The people spoke.
						</Paragraph>
						<Paragraph direction="down">
							And from the election, more history was made. More
							than 1,000 LGBTQ candidates ran for office, and the
							first transgender state senator was elected. Bigger
							news came when a woman, a Black woman with Asian and
							Indian heritage, was chosen as vice president, and
							will now be a heartbeat away from the presidency.
						</Paragraph>
						<Paragraph direction="down">
							Driving these history-making changes were young
							people. Around the globe, including here at BU, the
							drumbeat of student activism thumped loudly. For
							climate change. For equality. For inclusion. For
							their future.
						</Paragraph>

						<Paragraph direction="down">
							<div className="ahead-text">
								Ahead, we list moments that defined 2020 for
								Boston University.
							</div>
						</Paragraph>
					</BannerContent>
				</Banner>
				<ChapterNavigation index={number} />
			</Layout>
		</Context.Template.Provider>
	)
}

const IntroArrow = (props) => {

	return (
		<motion.svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 6.01 77.2"
			height="77.2"
			width="6.01"
			className="navDownArrow"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1, transition: { delay: 2 } }}
		>
			<g id="thinArrowDown">
				<path d="M3,77.2,0,71.73H6Z" fill="#fff" />
				<path d="M2.85,73.25V0" fill="none" stroke="#fff" />
			</g>
		</motion.svg>
	)
}

//Image Queries ------------------------------------------------------
export const queryCover = graphql`
  {
    coverImage: file(relativePath: {eq: "nav/nav_ages.jpg"}) {
      id
      childImageSharp {
        fluid(maxWidth: 2000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
